export class Subject{
    id : number;
    subjectCode : string;
    subjectName : string; 
    displayOrder : number;
} 